import { render, staticRenderFns } from "./BikyConfigKnowledgeBase.vue?vue&type=template&id=3228c56c&scoped=true&"
import script from "./BikyConfigKnowledgeBase.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigKnowledgeBase.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigKnowledgeBase.vue?vue&type=style&index=0&id=3228c56c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3228c56c",
  null
  
)

export default component.exports